import { Option } from '@/models/interfaces';

const CHE_ZIP_TABLE: { [code: string]: string } = {
  '10': 'Vaud',
  '11': 'Vaud',
  '12': 'Genève',
  '13': 'Vaud',
  '14': 'Vaud',
  '15': 'Vaud',
  '16': 'Vaud',
  '17': 'Fribourg',
  '18': 'Fribourg',
  '19': 'Valais',
  '20': 'Neuchâtel',
  '21': 'Neuchâtel',
  '22': 'Neuchâtel',
  '23': 'Neuchâtel',
  '24': 'Neuchâtel',
  '25': 'Neuchâtel',
  '26': 'Neuchâtel',
  '27': 'Neuchâtel',
  '28': 'Jura',
  '29': 'Jura',
  '30': 'Berne',
  '31': 'Berne',
  '32': 'Berne',
  '33': 'Berne',
  '34': 'Berne',
  '35': 'Berne',
  '36': 'Berne',
  '37': 'Berne',
  '38': 'Berne',
  '39': 'Valais',
  '40': 'Bâle-Ville',
  '41': 'Bâle-Campagne',
  '42': 'Soleure',
  '43': 'Soleure',
  '44': 'Bâle-Campagne',
  '45': 'Soleure',
  '46': 'Soleure',
  '47': 'Argovie',
  '48': 'Argovie',
  '49': 'Argovie',
  '50': 'Argovie',
  '51': 'Argovie',
  '52': 'Argovie',
  '53': 'Argovie',
  '54': 'Argovie',
  '55': 'Argovie',
  '56': 'Argovie',
  '57': 'Argovie',
  '58': 'Argovie',
  '59': 'Argovie',
  '60': 'Lucerne',
  '61': 'Lucerne',
  '62': 'Lucerne',
  '63': 'Nidwald',
  '64': 'Schwytz',
  '65': 'Tessin',
  '66': 'Tessin',
  '67': 'Tessin',
  '68': 'Tessin',
  '69': 'Tessin',
  '70': 'Grisons',
  '71': 'Grisons',
  '72': 'Grisons',
  '73': 'Grisons',
  '74': 'Grisons',
  '75': 'Grisons',
  '76': 'Grisons',
  '77': 'Grisons',
  '78': 'Grisons',
  '79': 'Grisons',
  '80': 'Zurich',
  '81': 'Zurich',
  '82': 'Schaffhouse',
  '83': 'Zurich',
  '84': 'Zurich',
  '85': 'Thurgovie',
  '86': 'Thurgovie',
  '87': 'Glaris',
  '88': 'Saint-Gall',
  '89': 'Saint-Gall',
  '90': 'Saint-Gall',
  '91': 'Appenzell Rhodes-Intérieures',
  '92': 'Appenzell Rhodes-Extérieures',
  '93': 'Saint-Gall',
  '94': 'Saint-Gall',
  '95': 'Saint-Gall',
  '96': 'Saint-Gall',
  '97': 'Saint-Gall',
  '98': 'Saint-Gall',
  '99': 'Saint-Gall',
};

const CHE_CANTONS: { [code: string]: string } = {
  AG: 'Argovie',
  AI: 'Appenzell Rhodes-Intérieures',
  AR: 'Appenzell Rhodes-Extérieures',
  BE: 'Berne',
  BL: 'Bâle-Campagne',
  BS: 'Bâle-Ville',
  FR: 'Fribourg',
  GE: 'Genève',
  GL: 'Glaris',
  GR: 'Grisons',
  JU: 'Jura',
  LU: 'Lucerne',
  NE: 'Neuchâtel',
  NW: 'Nidwald',
  OW: 'Obwald',
  SG: 'Saint-Gall',
  SH: 'Schaffhouse',
  SO: 'Soleure',
  SZ: 'Schwytz',
  TG: 'Thurgovie',
  TI: 'Tessin',
  UR: 'Uri',
  VD: 'Vaud',
  VS: 'Valais',
  ZG: 'Zoug',
  ZH: 'Zurich',
};

const CHE_OPTIONS: Array<Option> = [
  { value: 'AG', label: 'Argovie' },
  { value: 'AI', label: 'Appenzell Rhodes-Intérieures' },
  { value: 'AR', label: 'Appenzell Rhodes-Extérieures' },
  { value: 'BE', label: 'Berne' },
  { value: 'BL', label: 'Bâle-Campagne' },
  { value: 'BS', label: 'Bâle-Ville' },
  { value: 'FR', label: 'Fribourg' },
  { value: 'GE', label: 'Genève' },
  { value: 'GL', label: 'Glaris' },
  { value: 'GR', label: 'Grisons' },
  { value: 'JU', label: 'Jura' },
  { value: 'LU', label: 'Lucerne' },
  { value: 'NE', label: 'Neuchâtel' },
  { value: 'NW', label: 'Nidwald' },
  { value: 'OW', label: 'Obwald' },
  { value: 'SG', label: 'Saint-Gall' },
  { value: 'SH', label: 'Schaffhouse' },
  { value: 'SO', label: 'Soleure' },
  { value: 'SZ', label: 'Schwytz' },
  { value: 'TG', label: 'Thurgovie' },
  { value: 'TI', label: 'Tessin' },
  { value: 'UR', label: 'Uri' },
  { value: 'VD', label: 'Vaud' },
  { value: 'VS', label: 'Valais' },
  { value: 'ZG', label: 'Zoug' },
  { value: 'ZH', label: 'Zurich' },
];

function getSwitzerlandOSM(input: string): { aL4: string; aL6: string } | null {
  let aL4 = CHE_CANTONS[input];
  if (!aL4) aL4 = CHE_ZIP_TABLE[input.slice(0, 2)] ?? '';
  return { aL4: aL4, aL6: '' };
}

export { CHE_OPTIONS, getSwitzerlandOSM };
